<template>
  <div>
    <div class="animates-items mb16 verticallyCenter">
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="fontSize"
        title="字号"
        titlePosition="allInOneLine"
        :sliderMax="100"
        suffix="px"
      />
    </div>
    <div class="animates-items">
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDuration"
        title="持续"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDelay"
        title="延迟"
        titlePosition="singleLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <div class="verticallyCenter">
        <div class="mr16">触发</div>
        <div class="content">
          <el-radio-group v-model="animateDataVal.animationIterationCount">
            <el-radio
              v-for="(option, index) in triggerstyles.list"
              :key="index"
              :label="option.value"
              :disabled="option.disabled"
              >{{ option.title }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fontSize-setting",
  components: {},
  props: {
    animateData: {
      type: Object
    }
  },
  data() {
    return {
      triggerstyles: {
        type: "触发次数",
        checked: "单次触发",
        list: [
          {
            value: 1,
            disabled: false,
            title: "单次触发"
          },
          {
            value: 2,
            disabled: false,
            title: "多次触发"
          }
        ]
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    animateDataVal: {
      get() {
        return this.animateData
      },
      set(newVal) {
        this.$emit("update:animateData", newVal)
      }
    },
    fontSize: {
      get() {
        let triggerType = this.animateDataVal.triggerType
        let colorName = `${triggerType}FontSize`
        return parseInt(this.animateDataVal.variable[colorName])
      },
      set(newVal) {
        let triggerType = this.animateDataVal.triggerType
        let colorName = `${triggerType}FontSize`
        this.animateDataVal.variable[colorName] = newVal + "px"
      }
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
